var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth-container',{attrs:{"page":_vm.page}},[_c('h2',{staticClass:"mb-4"},[_vm._v("Proposal Information")]),_c('proposal-form',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }